import Content from "./Content";
import { IWizardStep } from "../../../../../wizard/types";

export const createConfigStep5: IWizardStep = {
  width: "552px",
  content: Content,
  stepName: "step5",
};
